var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex f-align-center ld-switch-input",class:{ 'is-mobile': _vm.mobile },on:{"click":_vm.toggleSwitch}},[_c('span',[_vm._v(_vm._s(_vm.items[_vm.active] ? _vm.items[_vm.active].label : ''))]),_vm._v(" "),_c('span',{staticClass:"ld-switch-icon",class:{ 'change': _vm.active === _vm.items.length - 1 }},[_c('i',{staticClass:"el-icon el-icon-caret-top"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9987c0da","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stories/switchInput/index.vue
// module id = null
// module chunks = 